import { render } from "./planeamentoPopUp.vue?vue&type=template&id=48801a28&scoped=true"
import script from "./planeamentoPopUp.vue?vue&type=script&lang=js"
export * from "./planeamentoPopUp.vue?vue&type=script&lang=js"

import "./planeamentoPopUp.vue?vue&type=style&index=0&id=48801a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48801a28"]])

export default __exports__